/**
 * Formatiert die Speichern-Bestätigung inkl. Anzahl entfernter (geleerter)
 * optionaler Felder (Spec §10 / Dummy `saveVcard`).
 *
 * @param clearedCount Anzahl der geleerten optionalen Kontakt-/Social-Felder
 */
export function savedToast(clearedCount: number): string {
  return clearedCount > 0
    ? `Gespeichert · ${clearedCount} Feld(er) entfernt`
    : 'Gespeichert'
}
